export default "__VITE_ASSET__E_NlKGy6__"